<template>
  <div>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class="dialogTitle">Xác thực danh tính</md-dialog-title>
      <div class="bodyDialog">
        <div
          class="md-layout md-alignment-bottom-center"
          v-for="(item, index) in resolver.hints"
          :key="index"
          v-show="isShowOptions"
        >
          <label class="md-layout-item md-size-40 md-form-label">
            Gửi mã xác nhận đến:
          </label>
          <div class="md-layout-item">
            <md-field>
              <md-input v-model="item.phoneNumber" readonly></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-button
              class="md-success md-just-icon md-round"
              @click="confirmAction(index)"
            >
              <md-icon>done</md-icon>
            </md-button>
          </div>
        </div>
        <div id="recaptcha-container"></div>
        <div
          class="md-layout md-alignment-bottom-center"
          v-show="isShowCodeInput"
        >
          <label class="md-layout-item md-size-40 md-form-label">
            Nhập mã xác nhận:
          </label>
          <div class="md-layout-item">
            <md-field>
              <md-input v-model="verificationCode"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-button class="md-dense md-success" @click="confirmCode()"
              >Xác nhận</md-button
            >
          </div>
        </div>
      </div>
      <md-dialog-actions>
        <md-button class="md-dense md-danger" @click="closeDialog"
          >Đóng</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import firebase from "@/services/firebase-init.js";
import "firebase/auth";
export default {
  props: ["showDialog", "resolver"],
  data() {
    return {
      phone: this.phone,
      hintSelected: 0,
      isShowOptions: true,
      isShowCodeInput: false,
      verificationCode: null,
      verificationId: null,
    };
  },
  created() {
    console.log(this.resolver);
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    confirmAction(index) {
      var _this = this;
      this.isShowOptions = false;
      if (
        this.resolver.hints[index].factorId ===
        firebase.auth.PhoneMultiFactorGenerator.FACTOR_ID
      ) {
        var appVerifier = new firebase.auth.RecaptchaVerifier(
          "recaptcha-container"
        );
        appVerifier.render().then(function (widgetId) {
          window.recaptchaWidgetId = widgetId;
        });
        var phoneInfoOptions = {
          multiFactorHint: _this.resolver.hints[index],
          session: _this.resolver.session,
        };
        var phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
        return phoneAuthProvider
          .verifyPhoneNumber(phoneInfoOptions, appVerifier)
          .then(function (verificationId) {
            _this.verificationId = verificationId;
            _this.isShowCodeInput = true;
          });
      }
    },
    confirmCode() {
      var cred = firebase.auth.PhoneAuthProvider.credential(
        this.verificationId,
        this.verificationCode
      );
      var multiFactorAssertion =
        firebase.auth.PhoneMultiFactorGenerator.assertion(cred);
      // Complete sign-in.
      this.resolver
        .resolveSignIn(multiFactorAssertion)
        .then((res) => {})
        .catch((error) => {
          if (error.message == "INVALID_CODE") {
            this.$messageError("Sai mã xác nhận");
            this.$emit("closeDialog");
          }
        });
    },
  },
};
</script>
<style scoped>
.dialogTitle {
  padding: 10px;
  text-align: center;
  background-image: linear-gradient(to left, #3999b9 0%, #184e94 100%);
  color: white;
}
.bodyDialog {
  padding: 10px;
  width: 25vw;
}
</style>
